// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.pricing-templates__title[data-v-73b57756] {\n  display: block;\n  margin-bottom: -10px;\n  color: #5a5964;\n  font-weight: normal;\n  font-size: 10px;\n}\n.pricing-templates__btn[data-v-73b57756] {\n  margin: 10px 10px 0;\n}\n", ""]);
// Exports
module.exports = exports;
